import {
  FlightDetailsSegment as CoreFlightDetailsSegment,
  type FlightDetailsSegmentComponentProps,
} from "@b2bportal/core-flights/overridable";
import {
  IconNameEnum,
  useFlightStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import { CoreFlightsComponent } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Icon } from "@tenant/ui";
import defaultStyles from "./styles.module.scss";

export const FlightDetailsSegment = ({
  children,
  ...rest
}: FlightDetailsSegmentComponentProps) => {
  const { t } = useI18nContext();
  const COMPONENT_KEY = CoreFlightsComponent.FlightDetailsSegment;
  const styles = useFlightStyles(COMPONENT_KEY, defaultStyles);
  const technicalStops = rest.segment.stops;
  const [, cn] = useModuleBEM(styles, COMPONENT_KEY);

  return (
    <CoreFlightDetailsSegment {...rest}>
      {technicalStops > 0 && (
        <div className={cn("technical-stops")}>
          <div className={cn("technical-stops-header")}>
            <Icon iconName={IconNameEnum.airplaneArrive} />
            <span>
              {t("stopDetails.technicalStop", { count: technicalStops })}
            </span>
          </div>
          <div className={cn("technical-stops-description")}>
            <Icon iconName={IconNameEnum.info} />
            <p>{t("stopDetails.technicalStopDescription")}</p>
          </div>
        </div>
      )}
      {children}
    </CoreFlightDetailsSegment>
  );
};
